'use client';

import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';


import CompactLayout from '../../layouts/compact';

import { varBounce, MotionContainer } from '../animate';
import Image from '../image';

// ----------------------------------------------------------------------

export default function NotFound() {
    const navigate = useNavigate();
  return (
    <CompactLayout>
      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant='h4'  sx={{ mb: 2, fontFamily:'Roboto Flex', fontWeight: '600', }}>
            Sorry, Page Not Found!
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be
            sure to check your spelling.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Image
          src='/assets/page_not_found.jpg'
          alt="page_not_found"
            sx={{
              height: 260,
              my: { xs: 5, sm: 1 },
            }}
          />
        </m.div>

        <Button onClick={() => navigate('/')}  size="large"  variant="contained" sx={{ fontFamily:'Roboto Flex', fontWeight: '600',p:'8px 35px'  }}>
          Go to Home
        </Button>
      </MotionContainer>
    </CompactLayout>
  );
}
